import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'lyceo-skeleton-text',
  imports: [],
  templateUrl: './skeleton-text.component.html',
  styleUrls: ['./skeleton-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonTextComponent {
  public animated: InputSignal<boolean> = input<boolean>(true);

  @HostBinding('class.animated')
  public get isAnimated(): boolean {
    return this.animated();
  }
}
